import { render } from "./TipDialog.vue?vue&type=template&id=b9c0f6c8&scoped=true"
import script from "./TipDialog.vue?vue&type=script&lang=js"
export * from "./TipDialog.vue?vue&type=script&lang=js"

import "./TipDialog.vue?vue&type=style&index=0&id=b9c0f6c8&lang=scss"
import "./TipDialog.vue?vue&type=style&index=1&id=b9c0f6c8&lang=scss&scoped=true"

import exportComponent from "/root/.jenkins/workspace/高保障-门户海南大学-前端页面-saas/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9c0f6c8"]])

export default __exports__